export default __webpack_public_path__ + "afc00107624bc7170b4fed16c43ff7f3.png";